/* global axios */

export const state = {
  token: null,
};

export const getters = {
  getPanelToken: _state => _state.token,
};

export const actions = {
  fetchPanelToken: async ({ commit }) => {
    try {
      const { data } = await axios.get('/api/v1/panel_token');
      commit('SET_PANEL_TOKEN', data.token);
    } catch (error) {
      // Never keep forwarding a stale token after a failed refresh.
      commit('SET_PANEL_TOKEN', null);
      throw error;
    }
  },
};

export const mutations = {
  SET_PANEL_TOKEN(_state, token) {
    _state.token = token;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
